//
//
//
//

export default {
  created () {
    this.$vux.loading.show({text: '加载中'})
    if (this.$route.query.type) {
      this.$_share_router(this.$route.query.type)
    } else {
      this.$vux.loading.hide()
      this.$vux.toast.show({
        type: 'warn',
        text: '未获取到用户类型'
      })
    }
  },
  methods: {
    /**
     * SPECIFIC_PERSONAL_ORDINARY 个人-普通
     * SPECIFIC_PERSONAL_PROFESSION 个人-专业
     * SPECIFIC_PERSONAL_PRACTITIONERS 个人-从业人员
     * SPECIFIC_ORG_ORDINARY 机构-普通
     * SPECIFIC_ORG_PROFESSION 机构-专业
     * SPECIFIC_ORG_ORG 机构-金融机构
     * SPECIFIC_ORG_PRACTITIONERS 机构-本机构
     * SPECIFIC_ORG_PRODUCT 机构_产品
     * @return {[type]} [description]
     */
    $_share_router (type) {
      let _this = this
      if (type === 'SPECIFIC_PERSONAL_ORDINARY') { // 个人-普通
        _this.$router.push({path: '/share/one'})
      }
      if (type === 'SPECIFIC_PERSONAL_PROFESSION') { // 个人-专业
        _this.$router.push({path: '/share/two'})
      }
      if (type === 'SPECIFIC_PERSONAL_PRACTITIONERS') { // 个人-从业人员
        _this.$router.push({path: '/share/three'})
      }
      if (type === 'SPECIFIC_ORG_ORDINARY') { // 机构-普通
        _this.$router.push({path: '/share/four'})
      }
      if (type === 'SPECIFIC_ORG_PROFESSION') { // 机构-专业
        _this.$router.push({path: '/share/five'})
      }
      if (type === 'SPECIFIC_ORG_ORG') { // 机构-金融机构
        _this.$router.push({path: '/share/six'})
      }
      if (type === 'SPECIFIC_ORG_PRACTITIONERS') { // 机构-本机构
        _this.$router.push({path: '/share/seven'})
      }
      if (type === 'SPECIFIC_ORG_PRODUCT') { // 机构_产品
        _this.$router.push({path: '/share/eight'})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Share/Index.vue